import React, { useRef, useEffect } from 'react'
import classNames from 'classnames';
import { Swiper, SwiperSlide } from "swiper/react/swiper-react.js";
import { Swiper as SwiperClass } from "swiper/types";
import { FreeMode, Pagination } from "swiper";
import './index.scss';

export default function DateSlider(props) {
  const { dateList = [], onSelectChanged = () => {} } = props;
  const swiperRef = useRef<SwiperClass | null>(null)
  // const [selectedIndex, setSelectedIndex] = useState(0);

  const onTapSlideItemHandler = (item, index) => {
    onSelectChanged(item);
  }
  
  useEffect(() => {
    if (!swiperRef.current || !dateList || dateList.length === 0) return;
    let index = 0
    dateList.forEach((dateItem, i) => {
      if (!!dateItem.checked) {
        index = i;
      }
    })
    // console.log('滚动到 index 为', index, '的地方');
    const targetPos = index - 2 >= 0 ? index - 2 : 0
    swiperRef.current.slideTo(targetPos);
  }, [dateList]);

  return (
    <div className="date-slider-field">
      <Swiper
        className="date-list"
        autoplay={false}
        freeMode={true}
        loop={false}
        slidesPerView="auto"
        pagination={false}
        modules={[FreeMode, Pagination]}
        onInit={swiper => {
          swiperRef.current = swiper;
        }}
      >
        <div className="date-list">
          {
            dateList && dateList.map((item, i) => {
              return (
                <SwiperSlide key={item.dateDesc}>
                  <div
                    key={item.date}
                    className={classNames("date-item", {
                      disabled: item.reserveQuota === 0,
                      selected: !!item.checked
                    })}
                    onClick={() => onTapSlideItemHandler(item, i)}
                  >
                    {
                      item.weekDate && (
                        <div className="date-desc">{item.weekDate}</div>
                      )
                    }
                    <div className="date-text">{item.dateDesc}</div>
                    <i className="selected-icon" />
                    <i className="disabled-icon">已满</i>
                  </div>
                </SwiperSlide>
              )
            })
          }
        </div>
      </Swiper>
    </div>
  )
}
